import React from 'react';
import ReactDOM from 'react-dom/client';
import './global.css'; // Importa o CSS global
import App from './App';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import './locales/i18n'

// 🟦 Atualiza a variável --vh com base na altura real da viewport
const setViewportHeight = () => {
  const height = window.visualViewport?.height || window.innerHeight;
  const vh = height * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
};

// Aplica inicialmente
setViewportHeight();

// Atualiza em tempo real quando a janela é redimensionada ou há mudanças na viewport
window.addEventListener('resize', setViewportHeight);
window.addEventListener('orientationchange', setViewportHeight);
window.visualViewport?.addEventListener('resize', setViewportHeight);

// Função para obter o valor da variável CSS
const getCSSVariable = (variable) => {
  return getComputedStyle(document.documentElement).getPropertyValue(variable).trim();
};

// Obtenha o valor da variável '--fonte-tpf'
const fonteTPF = getCSSVariable('--fonte-tpf');

const theme = createTheme({
  typography: {
    fontFamily: `${fonteTPF}`,
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ThemeProvider theme={theme}>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </ThemeProvider>
);

